import { Flex, SecondaryButton, SubmitButton } from '@equifinance/shared';
import styled from 'styled-components';

export const NextPageContainer = styled(Flex)`${({ theme }) => `
  justify-content: end;
  gap: ${theme.padding[4]};
`}`;

export const PreviousPageButton = styled(SecondaryButton)`${({ theme }) => `
  width: 15%;
  height: 100%;
  padding: ${theme.padding[3]} ${theme.padding[5]};
`}`;

export const NextPageButton = styled(SubmitButton)`${({ theme }) => `
  width:15%;
  text-align: center;
  font-size: ${theme.fontSize[3]};
  font-weight: ${theme.fontWeight.bolder};
  justify-content: center;
`}`;

export const PrimaryPreviousPageButton = styled(NextPageButton)``;
